import { render } from "./ExcelToCsv.vue?vue&type=template&id=46864638&scoped=true"
import script from "./ExcelToCsv.vue?vue&type=script&lang=js"
export * from "./ExcelToCsv.vue?vue&type=script&lang=js"

import "./ExcelToCsv.vue?vue&type=style&index=0&id=46864638&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46864638"]])

export default __exports__